// ==========================
// Version 4 — components/PolaroidGrid.js (lazy/CLS tweaks)
// - Adds width/height + decoding for less CLS
// - Keeps responsive CSS masonry + brand pin
// ==========================
import React from 'react';
import { Link } from 'react-router-dom';

export default function PolaroidGrid({ memories = [] }) {
  const items = [...memories].sort((a, b) =>
    String(b.date || '').localeCompare(String(a.date || ''))
  );

  return (
    <div className="polaroid-wall">
      {items.map((m) => {
        const image = Array.isArray(m.imageUrls) && m.imageUrls.length ? m.imageUrls[0] : null;
        if (!image) return null; // photo-first grid
        const linkTo = m.firestoreId ? `/m/${m.firestoreId}` : '#';
        return (
          <figure key={m.firestoreId || m.id} className="polaroid">
            <Link to={linkTo} state={{ memory: m }} style={{ textDecoration: 'none' }}>
              <img
                src={image}
                alt=""
                className="polaroid__photo"
                loading="lazy"
                decoding="async"
                width="800"
                height="600"
                style={{ aspectRatio: '4 / 3', objectFit: 'cover' }}
              />
              <figcaption className="polaroid__caption">
                <span className="polaroid__title">{m.date || 'Untitled'}</span>
                {m.story ? <span className="polaroid__sub">{truncate(m.story, 64)}</span> : null}
              </figcaption>
            </Link>
            <div className="polaroid__pin">•</div>
          </figure>
        );
      })}
    </div>
  );
}

function truncate(s, n) {
  if (!s) return '';
  return s.length > n ? s.slice(0, n - 1) + '…' : s;
}
// ==========================
// End Version 4 — components/PolaroidGrid.js
// ==========================
